<template>
  <div>
    <Dialog ref="dialog" :config="config">
      <div class="InformBounced ">
        <h1>{{ readItem.title }}</h1>
        <p class="timeBox">{{ readItem.created_at }}</p>
        <div class="con" v-html="readItem.content"></div>

      </div>
    </Dialog>
  </div>
</template>
<script>
import Dialog from '../../../../components/public/Dialog'
export default {
  data() {
    return {
      config: {
        top: '20vh',
        width: '1200px',
        title: this.$fanyi('通知'),
        btnTxt: [this.$fanyi('关闭')],
      },

      readItem: {}
    }
  },
  components: { Dialog },
  computed: {
  },
  mounted() { },
  methods: {
    open(readItem) {
      this.readItem = readItem
      this.$refs.dialog.open(
        '',
        (cancel) => {
          cancel();
          this.Markasread()
        },
        () => {
          this.Markasread()
        }
      )
    },
    Markasread() {
      this.$emit('noticeReadNotice',)
    }
  },
}
</script>
<style lang="scss" scoped>
.InformBounced {
  max-height: 580px;
  width: 100%;

  overflow-y: auto;

  h1 {
    font-weight: 500;
    font-size: 18px;
    color: #121212;
    line-height: 20px;
    margin-bottom: 12px;
    text-align: center;
    padding: 0 60px;
  }

  .timeBox {
    font-weight: 400;
    font-size: 14px;
    color: #121212;
    line-height: 16px;
    text-align: center;
    margin-bottom: 23px;
    padding: 0 60px;
  }

  .con {
    font-weight: 400;
    font-size: 14px;
    color: #121212;
    line-height: 16px;




  }
}

/deep/.el-dialog {
  padding-top: 0px !important;

  .el-dialog__header {
    height: 70px;
    border-bottom: 1px solid #DFDFDF;
    display: flex;
    align-items: center;

    .el-dialog__headerbtn {
      margin-right: 15px;
    }
  }
}

/deep/.el-dialog__body {
  display: flex;
  padding-top: 30px !important;
  align-items: center;
}
</style>
